import type { ButtonWithTooltipProps } from "./button-with-tooltip.type";

import { Button, Tooltip } from "antd";

export const ButtonWithTooltip = ({
  tooltip,
  tooltipPlacement,
  ...buttonProps
}: ButtonWithTooltipProps) => {
  if (!tooltip) return <Button {...buttonProps} />;

  return (
    <Tooltip title={tooltip} placement={tooltipPlacement}>
      <Button {...buttonProps} />
    </Tooltip>
  );
};
